<template>
  <img :src="img" >
</template>
<script>
  import mime_types from '@/mime_types.json'
  import { 
    getImg, 
    setTemporalItem, 
    getTemporalItem 
  } from '@/general'

  export default {
    data(){
      return {
        img: ''
      }
    },
    props: {
      url: String
    },
    methods: {
      _arrayBufferToBase64(buffer) {
        var strData = "";
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            strData += String.fromCharCode(bytes[i]);
        }
        strData = window.btoa(strData);

        return strData;
      },
      async getImgURL(path){
        try {
          const fileName = path.split("/").at(-1);
          const fileExtention = path.split('.').at(-1);

          const cachedImg = getTemporalItem(`img_${fileName}`);
          if (cachedImg) {
            return cachedImg;
          }

          const response = await getImg(this, path);
          const binaryData = await response.arrayBuffer();
          const base64 = this._arrayBufferToBase64(binaryData);
          const mimeType = mime_types.find(mime_type => mime_type.extention === `.${fileExtention.toLowerCase()}`);
          const img = `data:${mimeType.mime_type};base64,${base64}`;

          setTemporalItem(`img_${fileName}`, img, 1000 * 60 * 60 * 24); // Cache for 24 hour

          return img;
        } catch (error) {
          console.log(`Error cargando la imagen. Error: ${error}`);
          return null;
        }
      }
    },
    async mounted(){
      this.img = await this.getImgURL(this.url)
    }
  }
</script>
